import { render, staticRenderFns } from "./showBox.vue?vue&type=template&id=5a8f24ea&scoped=true&"
import script from "./showBox.vue?vue&type=script&lang=js&"
export * from "./showBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8f24ea",
  null
  
)

export default component.exports